<div class="container-fluid p-0">
  <div class="col-12 background-mobile">
    @if (randomVideoUrl) {
      <video #videoElement
             autoplay
             loop
             muted
             playsinline
             preload="metadata"
             webkit-playsinline>
        <source [src]="randomVideoUrl"
                type="video/mp4">
      </video>
    }
    <div class="position-absolute top-0 start-0 h-100 w-100"
         style="z-index: 99;
    overflow-y: auto; display: flex;flex-direction: column;align-items: center;justify-content: center;gap: 20px">
      <div class="col-12 d-flex flex-column align-items-center justify-content-center logo-box-mobile text-center">
        <div
          [ngStyle]="{ 'background': Config.domain?.Details?.LogoBackgroundColor || '','opacity': Config.domain?.Details?.LogoBackgroundOpacity || 1}"
          style="padding: 8px">
          <img [src]="formatImage('', Config.domain?.Details?.LogoText)"
          >
        </div>
        <!--        <img src="/icons/logo-without-name.svg">-->
        <p>{{ 'PleaseSelectYourDesiredBranch' | translate }}</p>
      </div>
      <div class="menu-btn">
        @for (branch of branches; track $index) {
          <div (click)="branch.Details.IsActive && onDetailClick($index)"
               [class.disabled]="!branch.Details.IsActive"
               class="buttons">
            <div class="d-flex flex-row align-items-center justify-content-between">
              <p>{{ branch.Title }}</p>
              <img [src]="formatImage('', branch.Icon)"
                   style="width: 40px; height: 40px;">
            </div>
            <span>{{ branch.Details.Address }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
